import { produce } from 'immer';
import { CLEAR_DRAWER_STATE, SET_DRAWER_OPEN_STATE } from '../actions/drawerActions';
const initialState = {
    isOpen: false
};
const drawerReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_DRAWER_STATE: {
                return initialState;
            }
            case SET_DRAWER_OPEN_STATE: {
                draft.isOpen = action.payload;
                break;
            }
        }
    });
};
export default drawerReducer;
